import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CuttingToolType } from "@enums/cuttingToolType.enum";
import { MaterialType } from "@enums/materialType.enum";
import { RoughFinish } from "@enums/roughFinish.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { CuttingTool } from "@interfaces/models/cuttingTool.interface";
import { CuttingToolSpeedFeedSetting } from "@interfaces/models/cuttingToolSpeedFeedSetting.interface";
import { CuttingToolService } from "@services/cuttingTool.service";
import { ToastService } from "angular-toastify";
import { ToastApiError } from "@helpers/apiError";

@Component({
	moduleId: module.id,
	selector: "cuttingTools-id",
	styleUrls: ["cuttingTools-id.css"],
	templateUrl: "cuttingTools-id.html"
})
export class CuttingToolsIdAdminComponent {
	createEnabled = true;
	editEnabled = true;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	item: CuttingTool = new CuttingTool();
	itemType = "Cutting Tool";
	materials = GetPropertiesFromEnum(MaterialType).filter((m: any) => m.id !== MaterialType.NotApplicable);
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	roughFinishes: any;
	speedFeedSettings: CuttingToolSpeedFeedSetting[] = [];
	title: string = "View " + this.itemType;
	toolTypes: any;

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: CuttingToolService) {
		this.buildButtons("view");
		this.toolTypes = GetPropertiesFromEnum(CuttingToolType, true);
		this.roughFinishes = GetPropertiesFromEnum(RoughFinish, true);
		this.route.params
			.subscribe((params) => {
				if (params.id != "create") {
					if (params.id.split("_").length > 1) {
						this.getItem(params.id.split("_")[0]);
						this.edit();
					} else {
						this.getItem(params.id);
					}
				} else {
					this.create();
				}
			});
	}

	buildButtons(mode: string) {
		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
		}
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.item.speedFeedSettings = JSON.stringify(this.speedFeedSettings || []);
		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Created " + this.itemType);
					this.item = new CuttingTool();
					this.close();
				},
				(err) => { console.log(err); ToastApiError(this.toastService, err); }
			);
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	getItem(itemId: number) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					try {
						this.speedFeedSettings = this.item.speedFeedSettings ? JSON.parse(this.item.speedFeedSettings) : [];
					} catch (e) {
						this.speedFeedSettings = [];
					}
				},
				(err) => { console.log(err); ToastApiError(this.toastService, err); }
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	updateItem() {
		this.item.speedFeedSettings = JSON.stringify(this.speedFeedSettings || []);
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => this.toastService.success("Successfully Updated"),
				(err) => { console.log(err); ToastApiError(this.toastService, err); }
			);
	}
}
